<div class="flex flex-col gap-2 mb-2 no-select">
  <div class="text-base opacity-70 font-bold">{{ label }}</div>
  <div class="border p-2 rounded-md px-5">
    <div class="text-base italic font-light my-2">{{ comment }}</div>
    <div class="text-xs italic font-light text-right">{{ date | date: 'dd/MM/yyyy HH:mm' }}</div>
  </div>
</div>
